// extracted by mini-css-extract-plugin
module.exports = {"originalRatio":"SldpPlayer_originalRatio__17aV9","displayRatio":"SldpPlayer_displayRatio__EHGF9","player":"SldpPlayer_player__-zmw1","subStreamer":"SldpPlayer_subStreamer__IwhyG"};